import { FormattedMessage } from 'react-intl';
import { SessionExportField } from 'screens/modals/sessionExport/ExportParkingHistoryModal';
import { SessionProperty } from 'types';


type Props = {
    checkedFields: SessionExportField[];
    sorting: SessionProperty,
    setSorting: (value: SessionProperty) => void;
}

export const SortedByExportField = (props: Props) => {
    return (
        <div className="export-modal-section">
            <div className='flex-2-col-parent'>
                <div className='flex-2-col'>
                    <label htmlFor='export-sortby'>
                        <FormattedMessage id="PARKING_HISTORY_MODAL_SORT_BY" />
                    </label>
                </div>
                <div className='flex-2-col'>
                    <div className="select-wrap">
                        <select id="export-sortby" data-testid='export-sortby'
                            value={props.sorting}
                            onChange={(event) => props.setSorting(event.target.value as SessionProperty)}
                        >
                            {props.checkedFields?.map(({ value, label }: any, index: number) => (
                                <option key={index} value={value}>
                                    <FormattedMessage id={label} />
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    )
}